/**
 * File upload validators
 */

const INSURER_ATTENTION_EXTENSIONS = ['pdf', 'docx', 'xlsx'];
const INSURER_ATTENTION_MAX_SIZE = 30 * 1024 * 1024; // 30MB

/**
 * Validate insurer attention attachment file
 * @returns error message if validation fails, null if valid
 */
export const validateInsurerAttentionFile = (file: File): string | null => {
  const ext = file.name.split('.').pop()?.toLowerCase() ?? '';

  if (!INSURER_ATTENTION_EXTENSIONS.includes(ext)) {
    return 'ファイル拡張子が正しくありません。';
  }

  if (file.size > INSURER_ATTENTION_MAX_SIZE) {
    return '最大アップロードの容量は30MBです。';
  }

  return null;
};

/**
 * Get validator function based on upload context
 */
export const getValidatorForContext = (context: string): ((file: File) => string | null) | null => {
  switch (context) {
    case 'insurer_attention_attachment':
      return validateInsurerAttentionFile;
    default:
      return null;
  }
};
